<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title jpn="Spezifiziertes Handelsverkehrsrecht" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Name des Betreiberunternehmens</span>
            <span class="text">Xero Place Co., Ltd.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">repräsentative Person</span>
            <span class="text">Yuki Narita</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Firmenregistrierungsadresse/Geschäftssitzadresse</span>
            <span class="text">330-0854</span>
            <span class="text">Saitama-ken, Saitama-shi, Omiya-ku, Sakuragi-cho 1-195-1</span>
            <span class="text">Omiya Soramichi KOZ 4. Stock</span>

          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Telefonnummer</span>
            <span class="text">050-1724-5360</span>
            <span class="text">(*Rezeptionszeiten: Werktags 10:00-17:00)</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">E-Mail-Adresse</span>
            <span class="text">support@xeroplace.jp</span>
            <span class="text">*Für Anfragen nutzen Sie bitte den Chat auf der Website. Grundsätzlich antworten wir innerhalb von 2 Werktagen.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Preis</span>
            <span class="text">Anzeige für jedes Produkt</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
        class="shadow-box-title-description"
        title=""
        >
        <div class="text-container left">
            <span class="text">Notwendige Kosten außer dem Produktpreis</span>
            <span class="text">Kosten im Zusammenhang mit der Ausrüstung zur Nutzung der von unserem Unternehmen bereitgestellten Dienste, Internetverbindungsgebühren, Paketkommunikationsgebühren, Verbrauchssteuer und Überweisungsgebühren für die Zahlung.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Lieferzeit</span>
            <span class="text">Bei der Annahme von Bewerbungen</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Verkaufsmenge</span>
            <span class="text">Es gibt keine spezifischen Spezifikationen.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Zahlungsart</span>
            <span class="text">Wir akzeptieren Kreditkarte, PayPal und Amazon Pay.</span>
            <span class="text">*Aus Gründen der Kundenfreundlichkeit können wir nach erfolgter Zahlung keine Stornierungen akzeptieren. Vielen Dank für Ihr Verständnis.</span>
            <span class="text">Erfolgt die Zahlung nicht fristgerecht, wird sie automatisch storniert.</span>
            <span class="text">Zahlungszeitraum</span>
            <span class="text">Kreditkarte: Es gelten die Geschäftsbedingungen des Kreditkartenunternehmens.</span>
            <span class="text">PayPal: Basierend auf den PayPal-Bedingungen.</span>
            <span class="text">Amazonpay: Basierend auf den Allgemeinen Geschäftsbedingungen von Amazonpay.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Rückgabebedingungen und Frist</span>
            <span class="text">Generell akzeptieren wir keine Rücksendungen oder Umtausche, aber wenn wir zu 100 % ein Verschulden treffen, werden wir reagieren.</span>
            <span class="text">In den folgenden Fällen können wir jedoch nicht antworten. Vielen Dank für Ihr Verständnis.</span>
            <span class="text">Wenn der Artikel während des Liefervorgangs verloren geht oder beschädigt wird</span>
            <span class="text">Wenn keine Videoaufzeichnung von ungeöffneten Artikeln wie BOX usw. erfolgt.</span>
            <span class="text">*Wir lassen bei der Prüfung nachgeschrumpfter Produkte besondere Sorgfalt walten.</span>
            <span class="text">Wenn seit dem Erhalt des Produkts mehr als 10 Tage vergangen sind</span>
            <span class="text">Wenn Sie Kratzer usw. an einem Bewertungsartikel wie PSA feststellen, akzeptieren wir Ihren Antrag auf Umtausch oder Rückgabe aus diesem Grund.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Gewerbelizenz für Antiquitätenhändler</span>
            <span class="text">Nein. 431370066203</span>
            <span class="text">Xero Place Co., Ltd.</span>
            <span class="text">Saitama Prefectural Public Safety Commission</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SpecificCommerce',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),

  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.specific-commerce{
  width: 100%;
  max-width: 1000px;
  padding: 30px 20px 0;
  margin: 0 auto;
  .specific-commerce-title{
    display: flex;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.none{
            color: red;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
table.code {
  width: 100%;
  th, td {
    font-size: 16px;
    color: $white;
  }
  th {
    font-weight: normal;
    text-align: left;
    padding-right: 10px;
    width: 200px;
  }
  td {
    text-align: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .specific-commerce{
    .scroll-container{
      .shadow-box-title-description{
        .text-container{
          .text{
            font-size: 14px;
          }
        }
      }
    }
  }
  table.code {
    width: 100%;
    th, td {
      display: block;
      font-size: 14px;
    }
    th {
      text-align: left;
      padding-right: 0;
      &:after {
        content: '';
      }
    }
    td {
      text-align: left;
      padding-left: 0;
      padding-bottom: 10px;
    }
  }
  .left {
    text-align: left!important;
  }
}
</style>
